'use client';

import { useEffect, useState } from 'react';
import { PenLine } from 'lucide-react';
import { avisoError } from '@/lib/avisoCentral';
import { api, subir } from '@/lib/api';
import { Card, CardContent, CardDescription, CardHeader, CardTitle } from '@/components/ui/card';
import GestorFirma from '@/components/GestorFirma';

/** Perfil propio: cada usuario gestiona su firma (ver / subir / reemplazar / eliminar). */
export default function MiFirma() {
  const [firmaKey, setFirmaKey] = useState<string | null>(null);
  const [cargando, setCargando] = useState(true);

  useEffect(() => {
    api<{ firmaKey: string | null }>('/perfil/firma')
      .then((r) => setFirmaKey(r.firmaKey))
      .catch((e) => avisoError('No se pudo cargar su firma', e instanceof Error ? e.message : undefined))
      .finally(() => setCargando(false));
  }, []);

  return (
    <div className="space-y-6">
      <div className="flex items-start gap-3">
        <span className="mt-0.5 flex size-10 items-center justify-center rounded-lg bg-accent text-accent-foreground">
          <PenLine className="size-5" />
        </span>
        <div>
          <h1 className="text-2xl font-semibold tracking-tight">Mi firma</h1>
          <p className="text-sm text-muted-foreground">
            Su firma se estampará en el acta de reparto y en los documentos que usted firme.
          </p>
        </div>
      </div>

      <Card className="max-w-lg">
        <CardHeader>
          <CardTitle>Firma personal</CardTitle>
          <CardDescription>Suba una imagen de su firma (PNG/JPG).</CardDescription>
        </CardHeader>
        <CardContent>
          {cargando ? (
            <p className="py-6 text-center text-sm text-muted-foreground">Cargando…</p>
          ) : (
            <GestorFirma
              firmaKeyInicial={firmaKey}
              onSubir={async (file) => {
                const fd = new FormData();
                fd.append('file', file);
                const u = await subir<{ firma_key?: string | null }>('/perfil/firma', fd);
                return u.firma_key ?? null;
              }}
              onEliminar={async () => { await api('/perfil/firma', { method: 'DELETE' }); }}
            />
          )}
        </CardContent>
      </Card>
    </div>
  );
}
